import Vue from 'vue'
import VueRouter from 'vue-router'
import { Message } from 'element-ui'
import { hasPermission } from '@/utils/permission'

Vue.use(VueRouter)

const Layout = () => import('@/layout/index.vue')

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue')
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        meta: { title: '首页', permission: 'dashboard' },
        component: () => import('@/views/dashboard/index.vue')
      },
      {
        path: 'contract/list',
        name: 'ContractList',
        meta: { title: '合同列表', permission: 'contract:list' },
        component: () => import('@/views/contract/list.vue')
      },
      {
        path: 'contract/search',
        name: 'ContractSearch',
        meta: { title: '合同全文搜索', permission: 'contract:list' },
        component: () => import('@/views/contract/search.vue')
      },
      {
        path: 'contract/add',
        name: 'ContractAdd',
        meta: { title: '新增合同', permission: 'contract:add' },
        component: () => import('@/views/contract/add.vue')
      },
      {
        path: 'contract/edit/:id',
        name: 'ContractEdit',
        meta: { title: '编辑合同', permission: 'contract:edit' },
        component: () => import('@/views/contract/edit.vue')
      },
      {
        path: 'contract/detail/:id',
        name: 'ContractDetail',
        meta: { title: '合同详情', permission: 'contract:list' },
        component: () => import('@/views/contract/detail.vue')
      },
      {
        path: 'dept',
        name: 'Dept',
        meta: { title: '部门管理', permission: 'dept' },
        component: () => import('@/views/dept/index.vue')
      },
      {
        path: 'role',
        name: 'Role',
        meta: { title: '角色管理', permission: 'role' },
        component: () => import('@/views/role/index.vue')
      },
      {
        path: 'user',
        name: 'User',
        meta: { title: '用户管理', permission: 'user' },
        component: () => import('@/views/user/index.vue')
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('contract_token')

  if (to.path === '/login') {
    if (token) {
      next('/dashboard')
    } else {
      next()
    }
    return
  }

  if (!token) {
    next('/login')
    return
  }

  if (to.meta && to.meta.permission) {
    if (!hasPermission(to.meta.permission)) {
      Message.error('你没有权限访问该页面')
      next('/dashboard')
      return
    }
  }

  next()
})

export default router